import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home/Home";
import Contact from "./components/Contact/Contact";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import AutoScrollToTop from "./components/AutoScrollToTop";
import "./App.css";
import React, { useEffect } from "react";
import AOS from "aos";
import About from "./components/About/About";
import Pricing from "./components/Pricing/Pricing";
// import Login from "./components/Login/Login";
import MutualFund from "./components/MutualFundPage/MutualFund";
import Ipo from "./components/Ipo/Ipo";
import Xts from "./components/Xts/Xts";
import Retail from "./components/Retail/Retail";
import NRI from "./components/NRI/NRI";
import Hni from "./components/Hni/Hni";
import Margin from "./components/Margin/Margin";
import Technology from "./components/Technology/Technology";
import Download from "./components/Download/Download";
import AccountDetail from "./components/AccountDetail/AccountDetail";
import Equity from "./components/Equity/Equity";
import FutureOption from "./components/FutureOption/FutureOption";
import Insurance from "./components/Insurance/Insurance";
import InvestmentPhilosophy from "./components/InvestmentPhilosophy/InvestmentPhilosophy";
import Career from "./components/Career/Career";
import BrokerNorms from "./components/BrokerNorms/BrokerNorms";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import Disclaimer from "./components/Disclaimer/Disclaimer";
import StockBroker from "./components/StockBroker/StockBroker";

import InvestorComplaint from "./components/InvestorComplaint/InvestorComplaint";

import Stoxxo from "./components/Stoxxo/Stoxxo";
import EscalationMatrix from "./components/EscalationMatrix/EscalationMatrix";
import OpenAccount from "./components/OpenAccount/OpenAccount";
import BlogDetails1 from "./components/BlogDetails/BlogDetails1";
import BlogDetails2 from "./components/BlogDetails/BlogDetails2";
import BlogDetails3 from "./components/BlogDetails/BlogDetails3";
           
import Greeks from "./components/Greeks/Greeks";   
import SymphonyXTS from "./components/SymphonyXTS/SymphonyXTS";    

import AmiBrokers from "./components/AmiBrokers/AmiBrokers";   
import DocumentationProcessSimplified from "./components/DocumentationProcessSimplified/DocumentationProcessSimplified";
import Faq from "./components/Faq/Faq";  
import NriForeignNationals from "./components/NriForeignNationals/NriForeignNationals";    
import NriFaq from "./components/NriFaq/NriFaq";  
import Notices from "./components/Notices/Notices";


function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <Router>
      <AutoScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          {/* <Route path="/login" element={<Login />} /> */}
          <Route path="/xts" element={<Xts />} />
          <Route path="/Ipo" element={<Ipo />} />
          <Route path="/mutual-fund" element={<MutualFund />} />
          <Route path="/retail" element={<Retail />} />
          <Route path="/nri-fpi" element={<NRI />} />
          <Route path="/uhni" element={<Hni />} />
          <Route path="/margin" element={<Margin />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/download" element={<Download />} />
          <Route path="/bank-account-detail" element={<AccountDetail />} />
          <Route path="/equity" element={<Equity />} />
          <Route path="/future-option" element={<FutureOption />} />
          <Route path="/insurance" element={<Insurance />} />
          <Route
            path="/investment-philosophy"
            element={<InvestmentPhilosophy />}
          />
          <Route
            path="/greeks"
            element={<Greeks />}
          />
           <Route
            path="/symphony-XTS"
            element={<SymphonyXTS />}
          />
          <Route
            path="/ami-brokers"
            element={<AmiBrokers />}
          />
          <Route
            path="/DocumentationProcessSimplified"
            element={<DocumentationProcessSimplified />}
          />
          <Route
            path="/faq"
            element={<Faq />}
          />
          <Route
            path="/nri-foreign-nationals"
            element={<NriForeignNationals />}
          />
          <Route
            path="/nri-faq"
            element={<NriFaq />}
          />
          <Route path="/careers" element={<Career />} />
          <Route path="/broker-norm" element={<BrokerNorms />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route
            path="/investor-charter-stock-broker"
            element={<StockBroker />}
          />

           <Route
            path="/investor-complaint"
            element={<InvestorComplaint />} />


          <Route path="/stoxxo" element={<Stoxxo />} />
          <Route path="/escalation-matrix" element={<EscalationMatrix />} />
          <Route path="/open-account" element={<OpenAccount />} />
          <Route
            path="/the-rise-of-algorithmic-trading-in-india"
            element={<BlogDetails1 />}
          />
          <Route
            path="/traders-cut-costs-and-scale-profits"
            element={<BlogDetails2 />}
          />
          <Route
            path="/building-confidence-in-the-age-of-automation"
            element={<BlogDetails3 />}
          />
          <Route path="/notices" element={<Notices />} />
        </Routes>
      </main>
      <ScrollToTop />
      <Footer />
    </Router>
  );
}

export default App;
